import { styled } from "styled-components";

export const Divider = () => <StyledDivider />;

const StyledDivider = styled.div`
  margin: 7px 0 6px;
  height: 1px;
  opacity: 0.1;
  background: var(--active-bg);
`;
